import { type PropsWithChildren, useEffect } from 'react';

export const ScrollRestoration = ({ children }: PropsWithChildren) => {
  useEffect(
    () => () => {
      document.getElementById('main')?.scrollTo(0, 0);
    },
    []
  );
  return <>{children}</>;
};
